import {Component} from '@angular/core';
@Component({
  selector: 'app-pure-originals',
  templateUrl: './pure-originals.component.html',
  styleUrls: ['./pure-originals.component.css']
})
export class PureOriginalsComponent{}
